'use client';
import { SingleEventInfo } from '@/models/EventModels';
import React, { FC, useEffect, useState } from 'react';
import styles from './EventInnerPageDesktop.module.scss';
import BreadCrumbs from '@/shared/BreadCrumbs';
import EventDescription from '@/shared/EventDescription';
import BookingBlock from '@/shared/BookingBlock';
import { useTranslations } from 'next-intl';
import {OrganizationInfo} from "@/models/OrganizationModels";
import {useBackgroundImage} from "@/shared/BackgroundImageComponent/BackgroundImageProvider";
import classNames from "classnames";
interface EventInnerPageProps {
  className?: string;
  event?: SingleEventInfo;
}

const EventInnerPageDesktop: FC<EventInnerPageProps> = ({
      className = '',
      event,
    }) => {
  const t = useTranslations('BOOKING_BLOCK');
  const bread_crumbs = [
    { title: t('main'), link: '/' },
    { title: event?.title || '', link: null },
  ];

  const { setImageUrl } = useBackgroundImage();

  useEffect(() => {
    const poster_image = `url(${event?.poster_image || ''})`;
    setImageUrl(poster_image);
  }, [event, setImageUrl]);

  return (
    <div className={classNames(styles.root, className)}>
      <BreadCrumbs links={bread_crumbs} />
      <div className={styles.column}>
        <EventDescription event_info={event} />
        <BookingBlock event={event} />
      </div>
    </div>
  );
};

export default EventInnerPageDesktop;
